// src/components/Magazine/virginia.js
import React, {useState} from 'react';
import CloseIcon from '@mui/icons-material/Close';

import '../../styles/magazineGallery.scss';

function Virginia() {
  /*Costruire react things */
    let data=[
        {
            id: 1,
            imgSrc: '/images/Virginia/Virginia_1.jpg',
        },
        {
            id: 2,
            imgSrc: '/images/Virginia/Virginia_2.jpg',
        },
        {
            id: 3,
            imgSrc: '/images/Virginia/Virginia_3.jpg',
        },
        {
            id: 4,
            imgSrc: '/images/Virginia/Virginia_4.jpg',
        },
        {
            id: 5,
            imgSrc: '/images/Virginia/Virginia_5.jpg',
        },
        {
            id: 6,
            imgSrc: '/images/Virginia/Virginia_6.jpg',
        },
        {
            id: 7,
            imgSrc: '/images/Virginia/Virginia_7.jpg',
        },
        {
            id: 8,
            imgSrc: '/images/Virginia/Virginia_8.jpg',
        },
        {
            id: 9,
            imgSrc: '/images/Virginia/Virginia_9.jpg',
        },
        {
            id: 10,
            imgSrc: '/images/Virginia/Virginia_10.jpg',
        },
        {
            id: 11,
            imgSrc: '/images/Virginia/Virginia_11.jpg',
        },
        {
            id: 12,
            imgSrc: '/images/Virginia/Virginia_12.jpg',
        },
        {
            id: 13,
            imgSrc: '/images/Virginia/Virginia_13.jpg',
        },
        {
            id: 14,
            imgSrc: '/images/Virginia/Virginia_14.jpg',
        },
    ]
    const [model, setModel] = useState(false);
    const [tempimgSrc, setTempImgSrc] = useState('');
    const getImg = (imgSrc) =>{
        setTempImgSrc(imgSrc);
        setModel(true);
    }
  return (
    <>
    <div className={model ? "model open" : "model"}>
        <img src={tempimgSrc} alt="Virginia " />
        <CloseIcon onClick={()=> setModel(false)} />
    </div>
        <div className="gallery">
            {data.map((item, index)=>{
                return(
                    <div className='pics' key={index} onClick={()=> getImg(item.imgSrc)}>
                        <img src={item.imgSrc} alt="Virginia " style={{width: '100%'}} loading="lazy"/>
                    </div>
                )
            })}
        </div>
     
    </>
  );
}

export default Virginia;
